export default __webpack_public_path__ + "static/media/AgentPlugins.36e58e7e.md";